import { getConfigValue } from './config/runtimeConfig';

export const auth0Config = {
    client_id: getConfigValue('REACT_APP_AUTH0_CLIENT_ID'),
    domain: getConfigValue('REACT_APP_AUTH0_DOMAIN')
};
